<template>
  <div class="min-vh">
    <div v-if="isLoginPage">
      <CRow class="no-gutters px-3 px-sm-0">
        <b-col xl="4" class="text-center text-sm-left mb-0">
          <h1 class="mb-0 header-main text-uppercase">LIVE</h1>
        </b-col>
        <b-col xl="8" class="text-center text-sm-left mb-0">
          <div class="w-100 action-div"></div>
        </b-col>
      </CRow>

      <div class="main-theme mt-3 bg-white-border p-3">
        <b-tabs content-class="border m-0 px-3">
          <b-tab title="Live" active>
            <PostTable :pageId="pageId" :postTypeId="1" />
          </b-tab>
          <b-tab title="Post">
            <PostTable :pageId="pageId" :postTypeId="2" />
          </b-tab>
          <b-tab title="IG Post">
            <PostTable :pageId="pageId" :instagramId="instagramId" :postTypeId="3" />
          </b-tab>
        </b-tabs>
      </div>
    </div>

    <ModalGoToSetting ref="ModalGoToSetting" />
  </div>
</template>

<script>
import PostTable from "./Component/PostTable.vue";
import ModalGoToSetting from "./Component/ModalGoToSetting.vue";

export default {
  name: "LiveIndex",
  components: {
    PostTable,
    ModalGoToSetting
  },
  data() {
    return {
      pageId: null,
      instagramId: null,
      isLoginPage: false,
    };
  },
  created: async function() {
    await this.$store.commit("UPDATE_MAIN_LOADING", true);
    await this.checkLoginPage();
    if (!this.isLoginPage) this.$refs.ModalGoToSetting.show();
    await this.$store.commit("UPDATE_MAIN_LOADING", false);
  },
  methods: {
    async checkLoginPage() {
      await this.axios
        .get(`${this.$baseUrl}/livePost/checkLoginPage`)
        .then((data) => {
          console.log("check login page", data);
          if (data.result == 1) {
            this.isLoginPage = data.detail.id != 0;
            if (this.isLoginPage) {
              this.pageId = data.detail.pageId;
              this.instagramId = data.detail.instagramId;
            }
            console.log("login page", this.isLoginPage);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.action-div {
  text-align: end;
}
.word {
  border: 0px solid #cecdcd;
  border-radius: 24px;
  padding: 0.5rem 0.75rem;
  background-color: #f0eff9;
  display: inline-flex;
  margin: 0.5rem;
  justify-content: space-between;
  align-items: flex-start;
}
.word-container {
  border: 1px solid #cecdcd;
  border-radius: 4px;
  padding: 1rem;
  height: 600px;
  overflow-y: scroll;
}
@media (max-width: 767px) {
  .action-div {
    text-align: center;
  }
}
</style>
